const INTERACTIVE_ROW_CHILD_SELECTOR =
  '.p-checkbox, .p-checkbox-box, .p-checkbox-input, .p-button, button, a, input, textarea, select, label';

export const shouldIgnoreRowClick = (event?: Event): boolean => {
  const target = event?.target as HTMLElement | null;
  if (!target) return false;
  return Boolean(target.closest(INTERACTIVE_ROW_CHILD_SELECTOR));
};
